import { useRef, cloneElement, useCallback, useMemo } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useDetectOutsideClick } from 'client/hooks/useDetectOutsideClick'
import Fade from 'components/misc/Fade'
import styles from './styles/DropdownMenu.css'

const DropdownMenu = ({
  containerClassName,
  menuClassName,
  menuItemClassName,
  items,
  iconImg,
  trigger
}) => {
  const dropdownMenuRef = useRef(null)
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownMenuRef, false)

  const onClick = useCallback(() => {
    setIsActive((prev) => !prev)
  }, [])

  const usedTrigger = useMemo(() => {
    if (trigger) {
      return cloneElement(trigger, { onClick })
    }
    if (iconImg) {
      return (
        <img
          alt=''
          className={styles.dropdownMenuIconImg}
          onClick={onClick}
          src={iconImg}
        />
      )
    }
    return (
      <i
        className={classNames('fa fa-2x fa-ellipsis-h', styles.dropdownMenuIcon)}
        onClick={onClick}
      />
    )
  }, [trigger, iconImg, onClick])

  return (
    <div className={classNames(containerClassName, { [styles.dropdownCell]: isActive })} ref={dropdownMenuRef}>
      {usedTrigger}
      <Fade className={classNames(styles.defaultDropdownMenu, menuClassName)} show={isActive}>
        {items.map((menuItem, index) => {
          const { iconEl, label, handleClick } = menuItem
          return (
            <div
              key={index} className={classNames(styles.dropdownItem, menuItemClassName)} onClick={() => {
                onClick()
                handleClick()
              }}
            >
              {iconEl}
              <span className={styles.dropdownLabel}>{label}</span>
            </div>
          )
        })}
      </Fade>
    </div>
  )
}

DropdownMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(
    {
      iconEl: PropTypes.element,
      label: PropTypes.string,
      handleClick: PropTypes.func
    }
  )).isRequired,
  containerClassName: PropTypes.string,
  menuItemClassName: PropTypes.string,
  menuClassName: PropTypes.string,
  trigger: PropTypes.element
}

export default DropdownMenu
